import { IGanttVacationSetting, IIssueBoardApi } from "@schemas/issueBoardSchema";
import { ColDef } from "ag-grid-community";
import React, { useMemo } from "react";
import { usePutProjectByProjectIdGanttVacationsMutation } from "../../../../../openapi";
import { FailedAlert, MCLoader } from "../../../../components";
import ViewEditTable from "../../../../components/ViewEditTable/ViewEditTable";
import { VETEmptyValidator } from "../../../../components/ViewEditTable/ViewEditTableValidators";
import { useAppSelector } from "../../../../hooks";
import { formatShortDate } from "../../../../mc-shared/sharedUtils";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssueBoardGanttSettings: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const ganttSettings: IGanttVacationSetting[] = issueBoard.ganttVacationSettings || [];
  const [data, setData] = React.useState<IGanttVacationSetting[]>(ganttSettings);
  const [updateGanttVacations, { isLoading, error }] = usePutProjectByProjectIdGanttVacationsMutation();

  const colDefs: ColDef<IGanttVacationSetting>[] = useMemo<ColDef<IGanttVacationSetting>[]>(
    () => [
      {
        field: "title",
        headerName: "Ferie",
        editable: true,
      },
      {
        field: "startDate",
        headerName: "Fra dato",
        editable: true,
        cellEditor: "agDateCellEditor",
        valueFormatter: (params) => formatShortDate(params.value),
      },
      {
        field: "endDate",
        headerName: "Til dato",
        editable: true,
        cellEditor: "agDateCellEditor",
        valueFormatter: (params) => formatShortDate(params.value),
      },
    ],
    [data],
  );

  React.useEffect(() => {
    const _data = ganttSettings.map((item) => ({
      title: item.title,
      startDate: item.startDate ? new Date(item.startDate) : null,
      endDate: item.endDate ? new Date(item.endDate) : null,
    }));
    setData((prev) => {
      if (
        prev.length === _data.length &&
        prev.every(
          (p, i) =>
            p.title === _data[i].title && +p.startDate === +_data[i].startDate && +p.endDate === +_data[i].endDate,
        )
      ) {
        return prev; //fix to avoid infinite loop
      }
      return _data;
    });
  }, [ganttSettings]);

  const newItemTemplateObject = {
    title: "",
    dateFrom: new Date(),
    dateTo: new Date(),
  };

  return (
    <SettingsCardWrapper title="Gantt: Ferieinnstillinger">
      {isLoading === true && <MCLoader loading={isLoading} />}
      {error != null && <FailedAlert />}
      {error == null && (
        <>
          {data != null && (
            <ViewEditTable
              columns={colDefs}
              data={data}
              onSave={(data) =>
                updateGanttVacations({
                  projectId: project._id,
                  body: {
                    issueboardId: issueBoard._id,
                    ganttVacationSettings: data.map((g) => ({
                      startDate: g.startDate as string,
                      endDate: g.endDate as string,
                      title: g.title,
                    })),
                  },
                })
              }
              newItemTemplateObject={newItemTemplateObject}
              canEdit={true}
              validators={[VETEmptyValidator]}
            />
          )}
        </>
      )}
    </SettingsCardWrapper>
  );
};

export default IssueBoardGanttSettings;
